export const REGULAR = { value: 'REGULAR', emoji: '✔️' };
export const PLEB = { value: 'PLEB', emoji: '🧑‍🌾' };
export const PIRATE = { value: 'PIRATE', emoji: '☠️' };


